import Vue from 'vue'
import Router from 'vue-router'

import main from '@/views/main'
import error from '@/views/error'
import success from '@/views/success'
import venus_list from '@/views/venus_list'
import venus_list2 from '@/views/venus_list2'
import goods_list from '@/views/goods_list'
import goods_detail from '@/views/goods_detail'
import order_list from '@/views/order_list'
import order_detail from '@/views/order_detail'
import create_order from '@/views/create_order'
import tips from '@/views/tips'


import repay_order from '@/views/tranform_3'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		// {
		// 	path: '/',
		// 	name: 'main',
		// 	component: main,
		// 	meta: {
		// 		keepAlive: false,
		// 		requireAuth: false,
		// 		title: '热橙健康'
		// 	}
		// },
		{
			path: '/error',
			name: 'error',
			component: error,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '热橙健康'
			}
		},{
			path: '/tips',
			name: 'tips',
			component: tips,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '热橙健康'
			}
		},{
			path: '/success',
			name: 'success',
			component: success,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '热橙健康'
			}
		},{
			path: '/venus_list',
			name: 'venus_list',
			component: venus_list,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '热橙健康'
			}
		},{
			path: '/venus_list2',
			name: 'venus_list2',
			component: venus_list2,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '热橙健康'
			}
		},{
			path: '/goods_list',
			name: 'goods_list',
			component: goods_list,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '热橙健康'
			}
		},{
			path: '/',
			name: 'goods_list',
			component: goods_list,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '热橙健康'
			}
		},{
			path: '/goods_detail/:goods_id',
			name: 'goods_detail',
			component: goods_detail,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '热橙健康'
			}
		},{
			path: '/order_list',
			name: 'order_list',
			component: order_list,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '热橙健康'
			}
		},{
			path: '/order_detail',
			name: 'order_detail',
			component: order_detail,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '热橙健康'
			}
		},{
			path: '/create_order/:goods_id/:date/:time',
			name: 'create_order',
			component: create_order,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '热橙健康'
			}
		}
	]
})

router.beforeEach((to, from, next) => {
	window.dispatchEvent(new Event('resize'));
	if(to.query.token){
		sessionStorage.setItem('token',to.query.token)
		setTimeout(()=>{
			next()
		},20)
	}else if(to.query.orderId){
		next()
	} else{
		next()
	}
})

// 后置守卫，处理页面返回时的重绘
router.afterEach((to, from) => {
	 window.dispatchEvent(new Event('resize'));
  const oldWidth = document.body.style.width
  document.body.style.width = oldWidth === '100%' ? '99%' : '100%'
  Vue.nextTick(() => {
    document.body.style.width = oldWidth
  })
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js